import { render } from "./ModalCadastroVencido.vue?vue&type=template&id=c903958c&scoped=true"
import script from "./ModalCadastroVencido.vue?vue&type=script&lang=js"
export * from "./ModalCadastroVencido.vue?vue&type=script&lang=js"

import "./ModalCadastroVencido.vue?vue&type=style&index=0&id=c903958c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c903958c"]])

export default __exports__